//OrderFlowMyProducts.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useFetch from '../../hooks/useFetch';
// import OrderFlowProductWorldList from './OrderFlowProductWorldList';
import './OrderFlowProducts.css'; 
import OrderFlowEarningCalculator from './OrderFlowEarningCalculator';
import InvoiceOverlay from './InvoiceOverlay';

const OrderFlowMyProducts = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const [userId, setUserId] = useState(authState.user._id);
    const [userName, setUserName] = useState(authState.user.name);
    const [productId, setProductId] = useState(null);
    const [isMyProductsHovered, setIsMyProductsHovered] = useState(false);
    const [ownerId, setownerId] = useState(authState.user._id);
    const [ownerName, setownerName] = useState(authState.user.name);
    const [myUserCode, setMyUserCode] = useState(authState.user.think5whyscode);
    const [userLevel, setUserLevel] = useState(0);
    const [atLevel, setAtLevel] = useState(0);
    const [myProducts, setMyProducts] = useState([]);
    const [numberOfProducts, setNumberOfProducts] = useState([]);
    const [readLogs, setReadLogs] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [selectedReferralProductId, setSelectedReferralProductId] = useState(null);
    const [expandedDates, setExpandedDates] = useState([]);
    const [myReferralsList, setMyReferralsList] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [myReferralsCount, setMyReferralsCount] = useState(0);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);
    const [showBill, setShowBill] = useState(false);
    const [bill, setBill] = useState(false);
    
    const [isSubscriptionApplied, setIsSubscriptionApplied] = useState(false);
    const [subsApplyErrorMsg, setSubsApplyErrorMsg] = useState('');
    const [isPageTopupApplied, setIsPageTopupApplied] = useState(false);
    const [pageTopupApplyErrorMsg, setPageTopupApplyErrorMsg] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);

    const isLoggedIn = authState?.isLoggedIn || false;

    const dispatch = useDispatch();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/orderflow-home");
    };

    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    
    const [showTree, setShowTree] = useState(false);

    const [tree, setTree] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [errors, setErrors] = useState();


    const fetchMyProducts = useCallback(() => {
        const config = {
            url: "/myproducts/list",
            method: "post",
            headers: { Authorization: authState.token },
            data: {userId: userId}
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.myproducts)) {
                    setMyProducts(response.myproducts);
                    setNumberOfProducts(myProducts.length);
                } else {
                    console.error("Invalid response format: Product not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching MyProducts:", error);
            });
    }, [authState.token, fetchData]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMyProducts();
    }, [authState.isLoggedIn, fetchMyProducts]);

    // const getImage = (productImage) => {
    //     if (imageMap.hasOwnProperty(productImage)) {
    //         return imageMap[productImage];
    //     } else {
    //         return NoImageImage;
    //     }
    // };

    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const [showReferralsList, setShowReferralsList] = useState(false);

    const handleMyReferralsListClick = (productId, myUserCode, userLevel) => {
        setSelectedReferralProductId(prev => (prev === productId ? null : productId));
        // setSelectedProductId(prev => (prev === productId ? null : productId));

        setShowReferralsList(!showReferralsList);
        fetchMyReferralsList(productId, myUserCode, userLevel);
    };

    const handleMyReferralsCountClick = (productId, myUserCode, userLevel, atLevel) => {
        fetchMyReferralsCount(productId, myUserCode, userLevel, atLevel);
    };

    const fetchMyReferralsList = useCallback((productId, myUserCode, userLevel) => {
        setProductId(productId);
        setMyUserCode(myUserCode);
        setUserLevel(userLevel);
        const config = {
            url: "/myproducts/myreferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { productId: productId, advisorCode: myUserCode, userLevel: userLevel }
        };

        fetchData(config)
            .then(response => {
                // console.log("response from referral list endpoint: ", response);
                if (response && response.referralsList && Array.isArray(response.referralsList)) {
                    setMyReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Referral List not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral List:", error);
            });
        }, [authState.token, fetchData, userId, productId]);

        useEffect(() => {
            // fetchMyReferralsList(productId, myUserCode);
        }, [fetchMyReferralsList, setMyReferralsList]);

        const fetchMyReferralsCount = useCallback((productId, myUserCode, userLevel, atLevel) => {
            setProductId(productId);
            setMyUserCode(myUserCode);
            setAtLevel(atLevel);
            const config = {
                url: "/myproducts/myreferralscount",
                method: "post",
                headers: { Authorization: authState.token },
                data: { productId: productId, advisorCode: myUserCode, userLevel: userLevel, atLevel: atLevel }
            };

            fetchData(config, { showSuccessToast: false })
                .then(response => {
                    // console.log("response from referral list endpoint: ", response);

                    if (response) {
                        setMyReferralsCount(response.referralsCount);
                        setSelectedLevel(atLevel);
                    } else {
                        console.error("Invalid response format: Referral Count not found in response");
                    }
                })
                .catch(error => {
                    console.error("Error fetching Referral Count:", error);
                });
        }, [authState.token, fetchData, userId, productId, myUserCode, userLevel, atLevel]);

        useEffect(() => {
            // fetchMyReferralsCount(productId, myUserCode, atLevel);
        }, [fetchMyReferralsCount, setMyReferralsCount]);


        useEffect(() => {
            //
        }, [myReferralsCount, productId], myUserCode, atLevel, selectedLevel);

        const dateRangeType='A';
        const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
        const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
        const [customFromDate, setCustomFromDate] = useState(new Date().toISOString().split('T')[0]);
        const [customToDate, setCustomToDate] = useState(new Date().toISOString().split('T')[0]);

        const handleDownTheLineGetAllCount = (selectedProductId) => {
            setDownTheLineGetAllCountClicked(true);
            const fromDate = new Date().toISOString().split('T')[0];;
            const toDate = new Date().toISOString().split('T')[0];;
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'A', fromDate, toDate);
        };

        const handleDownTheLineGetYTDCount = (selectedProductId) => {
            setDownTheLineGetYTDCountClicked(true);
            // Calculate toDate (yesterday's date)
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

            const firstDateOfYear = new Date(today.getFullYear(), 0, 1); // Month is 0-based, so 0 represents January
            const fromDate = firstDateOfYear.toISOString().split('T')[0]; // Example: "2024-01-01"
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'Y', fromDate, toDate);
        };

        const handleDownTheLineGetMTDCount = (selectedProductId) => {
            setDownTheLineGetMTDCountClicked(true);
            // Calculate toDate (yesterday's date)
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

            const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
            const fromDate = firstDateOfMonth.toISOString().split('T')[0]; // Example: "2024-07-01"
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'M', fromDate, toDate);
        };

        const handleDownTheLineGetLastSevenDaysCount = (selectedProductId) => {
            setDownTheLineGetLastSevenDaysCountClicked(true);
            // Calculate toDate (yesterday's date)
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const toDate = yesterday.toISOString().split('T')[0]; 

            // Calculate fromDate (6 days before toDate)
            const sixDaysAgo = new Date(yesterday);
            sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
            const fromDate = sixDaysAgo.toISOString().split('T')[0]; 
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'W', fromDate, toDate);
        };

        const handleDownTheLineGetTodayCount = (selectedProductId) => {
            setDownTheLineGetTodayCountClicked(true);
            const fromDate = new Date().toISOString().split('T')[0];
            const toDate = new Date().toISOString().split('T')[0];
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'T', fromDate, toDate);
        };

        const handleDownTheLineGetCustomCount = (selectedProductId) => {
            setDownTheLineGetCustomCountClicked(true);
            const fromDate = customFromDate;
            const toDate = customToDate;
            fetchDownTheLineGetCount(selectedProductId, myUserCode, userId, 'C', fromDate, toDate);
        };

        const fetchDownTheLineGetCount = useCallback((selectedProductId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
            setProductId(selectedProductId);
            setMyUserCode(myUserCode);
            if (!selectedProductId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
                return;
            }
            const config = {
                url: "/orderflowmlmchart/downthelinecount",
                method: "post",
                headers: { Authorization: authState.token },
                data: { 
                    productId: selectedProductId, 
                    userCode: myUserCode, 
                    userId: myUserId, 
                    dateRangeType: dateRangeType, 
                    fromDate: fromDate,
                    toDate: toDate 
                }
            };
            // console.log("Request Payload fetchDownTheLineGetCount:", { selectedProductId, myUserCode, myUserId, dateRangeType, fromDate, toDate }); // Log the payload
            
            fetchData(config, { showSuccessToast: false })
                .then(response => {
                    // console.log("response from referral list endpoint: ", response);

                    if (response && response.referralsCount) {
                        setDownTheLineGetCount(response.referralsCount);
                    } else {
                        console.error("Invalid response format: Down The Line Referral Count not found in response");
                        setDownTheLineGetCount({
                            l1: { count: 0, totalCom: 0 },
                            l2: { count: 0, totalCom: 0 },
                            l3: { count: 0, totalCom: 0 },
                            l4: { count: 0, totalCom: 0 },
                            l5: { count: 0, totalCom: 0 },
                            l6: { count: 0, totalCom: 0 },
                            l7: { count: 0, totalCom: 0 },
                            l8: { count: 0, totalCom: 0 }
                        });
                    }
                })
                .catch(error => {
                    console.error("Error fetching Down The Line  Referral Count:", error);
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                });
        }, [authState.token, fetchData]);

        useEffect(() => {
                // fetchDownTheLineGetCount(productId, myUserCode, userId, dateRangeType, fromDate, toDate); 
        }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

        const sortedProducts = myProducts.sort((a, b) => {
            const dateA = new Date(a.purchaseDate);
            const dateB = new Date(b.purchaseDate);
            return dateB - dateA;
        });

        const toggleDateExpansion = (date) => {
            if (expandedDates.includes(date)) {
                setExpandedDates(expandedDates.filter(item => item !== date));
            } else {
                setExpandedDates([...expandedDates, date]);
            }
        };

        const logsByDate = readLogs.reduce((acc, log) => {
            const date = log.dateRead.split('T')[0];
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(log);
            return acc;
        }, {});

        const totalCount = Object.values(downTheLineGetCount).reduce((sum, level) => sum + level.count, 0);
        const totalCommission = Object.values(downTheLineGetCount).reduce((sum, level) => sum + parseFloat(level.totalCom), 0);

        const [showReferrals, setShowReferrals] = useState(false);

        const toggleReferralsList = () => {
        setShowReferrals(!showReferrals);
        };

    const gotoRCA = (productIdForComment, productNameForComment, userIdForComment, pageNumber ) => {
        // console.log("I am inside gotoRCA()");
        navigate("/rcas/add");
    };

    const handleMyProductsMouseEnter = () => {
        setIsMyProductsHovered(true);
    };

    const handleMyProductsMouseLeave = () => {
        setIsMyProductsHovered(false);
    };

    const amountInWords = (amount) => {
        const singleDigits = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const twoDigits = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tensMultiple = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
        const tensPower = ['Hundred', 'Thousand', 'Lakh', 'Crore'];
      
        if (amount === 0) return 'Zero Rupees';
      
        let words = '';
      
        if (amount >= 10000000) {
          words += `${singleDigits[Math.floor(amount / 10000000)]} Crore `;
          amount %= 10000000;
        }
      
        if (amount >= 100000) {
          words += `${singleDigits[Math.floor(amount / 100000)]} Lakh `;
          amount %= 100000;
        }
      
        if (amount >= 1000) {
          words += `${singleDigits[Math.floor(amount / 1000)]} Thousand `;
          amount %= 1000;
        }
      
        if (amount >= 100) {
          words += `${singleDigits[Math.floor(amount / 100)]} Hundred `;
          amount %= 100;
        }
      
        if (amount >= 20) {
          words += `${tensMultiple[Math.floor(amount / 10)]} `;
          amount %= 10;
        }
      
        if (amount > 0) {
          if (amount < 10) words += `${singleDigits[amount]}`;
          else words += `${twoDigits[amount - 10]}`;
        }
      
        return `${words.trim()} Rupees`;
      };

      const invoiceRef = useRef();

  const [showOverlay, setShowOverlay] = useState(false); 
  const handleShowOverlay = (product) => {
  setSelectedProduct(product);
  setShowOverlay(true);
};

  
  const handleApplySubscription = (productId, subsValidityDays) => {
    updateMyProductsForSubsActivation(productId, subsValidityDays);
  };

  const updateMyProductsForSubsActivation = useCallback((productId, subsValidityDays) => {
    const config = {
        url: "/myproducts/updatesubsactivation",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: userId, productId: productId, subsStartDate: new Date(), subsValidityDays: subsValidityDays }
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response.status) {
                isSubscriptionApplied(true); 
                setSubsApplyErrorMsg('Subscription Applied!!');
            } else {
                console.error("Invalid response format: Subscription Apply Request Not Updated. Retry!!");
                setSubsApplyErrorMsg('Subscription Apply Request Not  Not Updated. Retry!!');
            }
        })
        .catch(error => {
            console.error("Error Updating Subscription Apply Request:", error);
        });
}, [authState.token, fetchData, userId]);

useEffect(() => {

}, [updateMyProductsForSubsActivation, isSubscriptionApplied]);


  const handleApplyPageTopup = (productId, particulars, pageCount) => {
    saveIntoPageWallet(productId, particulars, pageCount);
  };

  const saveIntoPageWallet = useCallback((productId, particulars, pageCount) => {
    const config = {
        url: "/pagewallet",
        method: "post",
        headers: { Authorization: authState.token },
        data: { 
            userId: userId,
            myProductId: productId, 
            userName: userName,
            userCode: myUserCode, 
            particulars: particulars,
            pageCount: pageCount,
            dateCreated: new Date(),
         }
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response.status) {
                // isPageTopupApplied(true); 
                updateMyProductsForPageTopup(productId);
            } else {
                console.error("Invalid response format: Page Wallet Record Not Created. Retry!!");
                setPageTopupApplyErrorMsg('Page Wallet Record Not Created. Retry!!');
            }
        })
        .catch(error => {
            console.error("Error Creating Page Wallet Record:", error);
        });
}, [authState.token, fetchData, productId]);

useEffect(() => {

}, [saveIntoPageWallet]);

const updateMyProductsForPageTopup = useCallback((productId) => {
    const config = {
        url: "/myproducts/updatepagetopupstatus",
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: userId, productId: productId, applyDate: new Date() }
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response.status) {
                isPageTopupApplied(true); 
                setPageTopupApplyErrorMsg('Page Wallet Record Created and Topup Applied!!');
            } else {
                console.error("Invalid response format: Page Wallet Topup Status Not Updated. Retry!!");
                setPageTopupApplyErrorMsg('Page Wallet Topup Record Not Updated. Retry!!');
            }
        })
        .catch(error => {
            console.error("Error Updating Page Wallet Topup Status:", error);
        });
}, [authState.token, fetchData, userId]);

useEffect(() => {

}, [updateMyProductsForPageTopup, isPageTopupApplied]);
  
 return (
        <div className="min-h-screen bg-gray-900 text-gray-100">
          <header className="sticky top-0 z-50 bg-black border border-cyan-400 px-4 py-2 flex flex-row items-center justify-between shadow-lg mb-4">
            <div className='flex flex-col items-start justify-start'>
                <h2 className='text-xl lg:text-2xl font-bold text-yellow-200 text-center mb-2'>
                    <i className="fas fa-shopping-cart text-xl lg:text-2xl text-yellow-200"></i>Khareedo
                </h2>
                <h2 className='text-sm font-bold text-white text-center mb-2'>
                   My Products
                </h2> 
            </div>  
            <div>
                <div className="hidden md:flex items-center gap-3">
                    {isLoggedIn ? (
                        <>
                            <div className="text-xs text-left text-blue-300">{userName}</div>
                            <button
                                onClick={handleLogout}
                                className="p-2 mt-2 rounded-md bg-blue-600 hover:bg-blue-700 transition"
                                title="Logout"
                            >
                                ⏻
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                to="/login"
                                className="px-3 py-1 rounded-full border border-blue-700 text-sm text-blue-200 hover:bg-blue-900"
                            >
                                Login
                            </Link>
                            <Link
                                to="/signup"
                                className="px-3 py-1 rounded-full bg-blue-500 text-white text-sm hover:bg-blue-400"
                            >
                                Register
                            </Link>
                        </>
                    )}
                </div>
            
                {/* Mobile hamburger */}
                <button
                    onClick={() => setIsMobileMenuOpen((s) => !s)}
                    className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-blue-300 bg-blue-500"
                    aria-label="Toggle menu"
                >
                    {isMobileMenuOpen ? "×" : "☰"}
                </button>
            </div>
        </header>
    
        {/* Mobile menu content */}
        {isMobileMenuOpen && (
            <div className="md:hidden bg-black border-b border-cyan-400 px-4 py-2 animate-fadeIn">
                {isLoggedIn ? (
                    <div className="flex flex-row items-center justify-center gap-3">
                        <span className="text-blue-300 font-medium whitespace-nowrap h-7">
                            Welcome, {userName}
                        </span>
                        <button
                            onClick={handleLogout}
                            className="rounded-md bg-blue-600 hover:bg-blue-700 w-7 h-7 flex items-center justify-center text-white"
                            title="Logout"
                        >
                            ⏻
                        </button>
                    </div>
                ) : (
                    <div className="flex flex-row items-center justify-center gap-6">
                        <Link to="/login" className="text-blue-300 hover:text-yellow-300">
                            Login
                        </Link>
                        <span className="text-blue-500">|</span>
                        <Link to="/signup" className="text-blue-300 hover:text-yellow-300">
                            Register
                        </Link>
                    </div>
                )}
            </div>
        )}  

          <div className="product-container mt-4 px-4 sm:px-8">
            {myProducts.length < 1 ? (
              <div className="text-center text-gray-400 py-8">
                <p className="text-sm lg:text-xl sm:text-yellow-200">Your Purchase is Empty!!</p>
              </div>
            ) : (
              <div className="space-y-4 sm:space-y-6">
                {sortedProducts.map((product, index) => (
                  <div key={product.productCode} className="bg-white shadow-lg rounded-lg p-4 sm:p-6 mb-4 border border-gray-200">
                    <h2 className="text-blue-600 text-lg sm:text-xl font-bold text-center sm:text-left mb-4">Purchased Item# {index + 1}</h2>
                    <div className="mb-4 sm:mb-6 flex justify-center items-center">
                      <img 
                          src={
                              `/api/downloads/orderflow/products/${product.productCode}.png` 
                          }
                          alt={"No Image " + product.productName} 
                          className="w-full max-w-xs sm:max-w-md h-auto rounded-md object-cover"
                      />
                    </div>
                    <div className="details-container mb-4 sm:mb-6 text-center sm:text-left">
                      <h2 className="text-xl sm:text-2xl text-green-700 font-semibold mb-2">{product.productName}</h2>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4 text-sm sm:text-base">
                        <p className="text-gray-800">Brand: <span className="font-medium text-white">{product.brandName}</span></p>
                        <p className="text-gray-800">Seller: <span className="font-medium text-white">{product.sellerName}</span></p>
                        <p className="text-gray-800">Manufacturer: <span className="font-medium text-white">{product.manufacturerName}</span></p>
                        <p className="text-yellow-300 col-span-2">
                          Purchase Date: <strong className="text-white">{formatDateTime(product.purchaseDate)}</strong>
                        </p>
                      </div>
                    </div>
                      {product.isSubscription && (
                      <div className="mb-4 sm:mb-6">
                          <p className="text-base sm:text-lg text-green-600 mb-2 text-center sm:text-left">
                          This is a {product.isT5WSubs ? "Think5Whys" : ""} Subscription Valid for 
                          {` ${product.subsValidityDays} days`}
                          </p>
                          <p className="text-sm sm:text-base text-gray-200 mb-3 text-center sm:text-left">Remarks: {product.subsRemarks}</p>
                          {product.subsApplied === false ? (
                          <div className="space-y-2">
                              {isSubscriptionApplied ? (
                              <p className='text-base sm:text-lg text-green-800 text-center sm:text-left'>Subscription is Applied</p>
                              ) : (
                              <p className='text-base sm:text-lg text-red-600 text-center sm:text-left'>{subsApplyErrorMsg}</p>
                              )}
                              <button
                              className="w-full sm:w-auto py-2 px-4 text-white bg-orange-700 rounded hover:bg-orange-800 transition-colors disabled:opacity-50"
                              disabled={isSubscriptionApplied}
                              onClick={() => handleApplySubscription(product._id, product.subsValidityDays)}
                              >
                              Subscription is Not Applied!! Apply Now?
                              </button>
                          </div>
                          ) : (
                          <div className="space-y-1">
                              <p className="text-base sm:text-lg text-blue-800 text-center sm:text-left">Subscription is Applied</p>
                              <p className="text-sm sm:text-base text-blue-800 text-center sm:text-left">
                              Subscription Period: {formatDateTime(product.subsStartDate)}{' '} 
                              to{' '}{formatDateTime(product.subsEndDate)}
                              </p>
                          </div>
                          )}
                      </div>
                      )}
                    {/* ** */}
                      {product.isT5WPageTopup && (
                          <div className="mb-4 sm:mb-6">
                              <p className="text-base sm:text-lg text-green-600 mb-2 text-center sm:text-left">
                              This is a Think5Whys Books Page Read Topup for {product.pageTopupCount} pages
                              </p>
                              {product.pageTopupApplied === false ? (
                                  <div className="space-y-2">
                                      <p className="text-sm sm:text-base text-blue-800 mb-2 text-center sm:text-left">
                                          Remarks: {product.pageTopupRemarks}
                                      </p>
                                      {isPageTopupApplied ? (
                                      <p className="text-base sm:text-lg text-green-700 text-center sm:text-left">Topup Added to Page Wallet</p>
                                      ) : (
                                      <div className="space-y-2">
                                          { pageTopupApplyErrorMsg !== '' && (
                                              <p className="text-base sm:text-lg text-red-600 text-center sm:text-left">{pageTopupApplyErrorMsg}!! Please Retry.</p>
                                          )}
                                          <button
                                              className="w-full sm:w-auto py-2 px-4 text-white bg-orange-700 rounded hover:bg-orange-800 transition-colors disabled:opacity-50"
                                              disabled={isPageTopupApplied}
                                              onClick={() => handleApplyPageTopup(product._id, product.productName, product.pageTopupCount)}
                                          >
                                              Pages are not Added into Page Wallet!! Add Now?
                                          </button>
                                      </div>
                                      )}
                                  </div>
                              ) : (
                                  <p className="text-base sm:text-lg text-green-700 text-center sm:text-left">Topup Added to Page Wallet</p>
                              )}
                          </div>
                      )}
                      {/* ** */}
                      {product.isCombo && (
                          <div className="mb-4 sm:mb-6 text-center sm:text-left">
                          <p className="text-lg sm:text-xl text-blue-800 mb-1">This is a Combo/Kit</p>
                          <p className="text-xs sm:text-sm text-gray-700 mb-1">{product.comboName}</p>
                          <p className="text-xs sm:text-sm text-purple-800">{product.comboDetails}</p>
                          </div>
                      )}
                    <div className="mb-4 sm:mb-6 flex justify-center sm:justify-start">
                     <button
                        className="w-full sm:w-auto py-2 px-4 text-white bg-blue-700 rounded hover:bg-blue-800 transition-colors"
                        onClick={() => handleShowOverlay(product)}
                      >
                        Receipt cum Invoice
                      </button>
                      {showOverlay && (
                          <InvoiceOverlay
                          product={selectedProduct}
                          authState={authState}
                          amountInWords={amountInWords}
                          formatDateTime={formatDateTime}
                          onClose={() => setShowOverlay(false)}
                          />
                      )}
                    </div>

                    { product.isGeneral === false && (
                      <> 
                      {/* *Referral Starts* */}
                      <div className="mb-4 sm:mb-6">
                          <p className="text-base sm:text-lg text-purple-700 mb-3 text-center sm:text-left">
                          You are eligible for Multi Level Referral program. Under this program you can earn active & passive income as per the following chart:
                          </p>
                          <div className="flex justify-center sm:justify-start">
                            <button
                            className="w-full sm:w-auto py-2 px-4 text-white bg-blue-700 rounded hover:bg-blue-800 transition-colors"
                            onClick={() => setShowTable(!showTable)}
                            >
                            Click here to see Multi-Level referral income chart
                            </button>
                          </div>
                          {showTable && <OrderFlowEarningCalculator param1={product.offerPrice} param2={product.mlmPlan} />}
                      </div>
                      <div className="flex justify-center sm:justify-start mb-4 sm:mb-6">
                          <p className="text-base sm:text-lg text-green-600">
                          My Referrer: <strong className="text-white">{product.advisorName}</strong>
                          </p>
                      </div>
                      <div className="flex flex-col items-center mb-4 sm:mb-6">
                          <button
                              className="w-full sm:w-auto py-2 px-4 text-white bg-purple-700 rounded hover:bg-purple-800 transition-colors mb-2 sm:mb-0"
                              onClick={() => {
                              handleMyReferralsListClick(product.productId, product.userCode, product.userLevel);
                              toggleReferralsList();
                              }}
                          >
                              {showReferrals ? "Hide Referrals List" : "Show Referrals List"}
                          </button>

                          {showReferrals && (
                              <div className="p-4 sm:p-6 bg-gray-100 rounded-lg shadow-md mt-4 w-full">
                              {myReferralsList.length === 0 && selectedProductId === product.productId ? (
                                  <p className="text-red-600 text-center font-semibold text-sm sm:text-base">
                                  No referral sales yet for the product <span className="font-bold">{product.productName}</span>!
                                  </p>
                              ) : (
                                  <div className="space-y-3">
                                    {myReferralsList.map((referral, index) => (
                                    <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-sm p-3 sm:p-4">
                                        <p className="text-blue-700 font-semibold text-sm sm:text-base">
                                        {index + 1}. User: <span className="font-medium">{referral.userName}</span> ({referral.userCode})
                                        </p>
                                        <p className="text-gray-600 text-xs sm:text-sm">
                                        Purchase Date: <span className="font-medium">{new Date(referral.purchaseDate).toLocaleDateString()}</span>
                                        </p>
                                        <p className="text-gray-600 text-xs sm:text-sm">
                                        Purchase Price: <span className="font-medium text-green-600">₹{referral.salesPrice.toFixed(2)}</span>
                                        </p>
                                    </div>
                                    ))}
                                  </div>
                              )}
                              </div>
                              )}
                      </div>
                      <div className="flex flex-col items-center mb-4 sm:mb-6">
                          <button
                              className="w-full sm:w-auto py-2 px-4 text-white bg-orange-500 rounded hover:bg-orange-600 transition-colors mb-2 sm:mb-0 disabled:opacity-50"
                              onClick={() => handleDownTheLineGetAllCount(product.productId)}
                              disabled={downTheLineGetAllCountClicked}
                          >
                              Show Lifetime Count
                          </button>

                          {downTheLineGetAllCountClicked && downTheLineGetCount && (
                              <div className="w-full overflow-x-auto">
                                <table className="min-w-full bg-white border border-gray-300 rounded-lg overflow-hidden">
                                <thead className="bg-gray-800 text-white">
                                    <tr>
                                    <th className="py-2 sm:py-3 px-2 sm:px-4 uppercase font-semibold text-xs sm:text-sm">Level</th>
                                    <th className="py-2 sm:py-3 px-2 sm:px-4 uppercase font-semibold text-xs sm:text-sm">Members</th>
                                    <th className="py-2 sm:py-3 px-2 sm:px-4 uppercase font-semibold text-xs sm:text-sm">Commission</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-900">
                                    {Object.keys(downTheLineGetCount).map(level => (
                                    <tr key={level} className="border-b border-gray-200">
                                        <td className="py-2 sm:py-3 px-2 sm:px-4 text-gray-800 text-xs sm:text-sm">Level {level}</td>
                                        <td className="py-2 sm:py-3 px-2 sm:px-4 text-gray-800 text-xs sm:text-sm">{downTheLineGetCount[level]?.count || 0}</td>
                                        <td className="py-2 sm:py-3 px-2 sm:px-4 text-gray-800 text-xs sm:text-sm">{parseFloat(downTheLineGetCount[level]?.totalCom || 0).toFixed(2)}</td>
                                    </tr>
                                    ))}
                                    <tr className="bg-yellow-600 text-white">
                                    <td className="py-2 sm:py-3 px-2 sm:px-4 font-semibold text-xs sm:text-sm">Total</td>
                                    <td className="py-2 sm:py-3 px-2 sm:px-4 font-semibold text-xs sm:text-sm">{totalCount}</td>
                                    <td className="py-2 sm:py-3 px-2 sm:px-4 font-semibold text-xs sm:text-sm">{totalCommission.toFixed(2)}</td>
                                    </tr>
                                </tbody>
                                </table>
                              </div>
                          )}
                      </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      );
      
};

export default OrderFlowMyProducts;